import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type InlineStepper from './inline-stepper.vue'

interface InlineStepperItem {
  title?: string
  key?: any
  tip?: string
  [key: string]: any
}

// 定义组件props
export const inlineStepperProps = buildProps({
  current: {
    type: Number,
    default: 0,
  },
  items: {
    type: definePropType<InlineStepperItem[]>(Array),
    default: () => [],
  },
  mode: {
    type: String,
    values: ['flow-wizard', 'progress-log'],
    default: 'flow-wizard',
  },
} as const)

// props
export type InlineStepperProps = ExtractPropTypes<typeof inlineStepperProps>

// instance
export type InlineStepperInstance = InstanceType<typeof InlineStepper>
